import React from 'react';
import Careers from '../components/Careers';
import './Page.css';

function CareersPage() {
  return (
    <div className="page-wrapper">
      <Careers />
    </div>
  );
}

export default CareersPage;
